module.exports = __webpack_public_path__ + "img/sub-title-bg.e83e1043.png";